import React from 'react';
import PropTypes from 'prop-types';
import './Heading.css';

function Heading(props) {
  return React.createElement(
    `h${props.level}`,
    { className: 'edu-heading' },
    props.children
  );
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5])
};

Heading.defaultProps = {
  level: 2
};

export default Heading;



// WEBPACK FOOTER //
// ./src/components/edu/Heading.js